import { usePopper } from 'react-popper'
import ReactDOM from 'react-dom'
import FadeIn from 'ui/animations/animation-wrappers/FadeIn'
import React from 'react'
import usePopUp from './use-popup'
import propTypes from 'prop-types'
import useOnClickOutside from 'support/hooks/use-on-click-outside'

export default function PopUpElement (props) {
  const { placement = 'bottom', children, skidding = 0, distance = 0 } = props

  const {
    active,
    setActive,
    referenceElement
  } = usePopUp()

  const popUpSettings = [
    {
      name: 'offset',
      enabled: true,
      options: {
        offset: [skidding, distance]
      }
    }
  ]

  const [popUpElement, setPopUpElement] = React.useState(null)

  useOnClickOutside(popUpElement, (event) => {
    if (!referenceElement) {
      setActive(false)
    } else if (referenceElement && typeof (referenceElement.contains) === 'function' && !referenceElement.contains(event.target)) {
      setActive(false)
    }
  }, [referenceElement])

  const { styles, attributes } = usePopper(referenceElement, popUpElement, {
    placement: placement,
    modifiers: popUpSettings
  })

  return ReactDOM.createPortal(
    <FadeIn in={active} duration={100}>
      <div
        className='z-50'
        ref={setPopUpElement}
        style={styles.popper}
        {...attributes.popper}
      >
        {children}
      </div>
    </FadeIn>,
    document.body
  )
}

PopUpElement.propTypes = {
  /**
   * The placement of the PopUp.
   */
  placement: propTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'right',
    'right-start',
    'right-end',
    'left',
    'left-start',
    'left-end'
  ]),
  /**
   * lets you displace a popper element from its reference element.
   * Fine tune placement of the popUp on the X-axis,
   */
  skidding: propTypes.number,
  /**
   * lets you displace a popper element from its reference element.
   * Fine tune placement of the popUp on the Y-axis,
   */
  distance: propTypes.number,
  /**
   * The actual item that will popUp
   */
  children: propTypes.node
}
